import { View, ViewGenerator } from "binder";

export interface SelectorOptions{
    portraitPhone? : ()=>View<any>;
    landscapePhone? : ()=>View<any>;
    portraitTablet? : ()=>View<any>;
    landscapeTablet? : ()=>View<any>;
    portraitLargeTablet? : ()=>View<any>;
    landscapeLargeTablet? : ()=>View<any>;
    desktop?: ()=>View<any>;
    landscapeDefault?:()=>View<any>;
    portraitDefault?:()=>View<any>;
    default?: ()=>View<any>;
}
export class MediaSelector{
    private listenners : ((media?)=>void)[];
    constructor() {
        this.listenners = [];
        this.setupEvents();
    }
    public addListenner(listenner : (media)=>void){
        this.listenners.push(listenner);
    }
    public static GetView(options:SelectorOptions):View<any>{
        return <View<any>>MediaSelector.GetObjectByMediaType(options,false);
    }
    public static GetObjectByMediaType(options:SelectorOptions,shallEvaluateParameters:boolean):any{
        if(window.matchMedia("(min-width: 1025px)").matches){
            return this.generateView([options.desktop,options.default],shallEvaluateParameters);
        }else if(window.matchMedia("(min-width: 769px) and (max-width: 1024px) and (orientation: portrait)").matches){
            return this.generateView([options.portraitLargeTablet,options.portraitTablet,options.portraitDefault,options.default],shallEvaluateParameters);
        }else if(window.matchMedia("(min-height: 769px) and (max-height: 1024px) and (orientation: landscape)").matches){
            return this.generateView([options.landscapeLargeTablet,options.landscapeTablet,options.landscapeDefault,options.default],shallEvaluateParameters);
        }else if(window.matchMedia("(min-width: 481px) and (max-width: 768px) and (orientation: portrait)").matches){
            return this.generateView([options.portraitTablet,options.portraitLargeTablet,options.portraitDefault,options.default],shallEvaluateParameters);
        }else if(window.matchMedia("(min-height: 481px) and (max-height: 768px) and (orientation: landscape)").matches){
            return this.generateView([options.landscapeTablet,options.landscapeLargeTablet,options.landscapeDefault,options.default],shallEvaluateParameters);
        }else if(window.matchMedia("(min-width: 320px) and (max-width: 480px) and (orientation: portrait)").matches){
            return this.generateView([options.portraitPhone,options.portraitDefault,options.default],shallEvaluateParameters);
        }else if(window.matchMedia("(min-height: 320px) and (max-height: 480px) and (orientation: landscape)").matches){
            return this.generateView([options.landscapePhone,options.landscapeDefault,options.default],shallEvaluateParameters);
        }else{
            return this.generateView([options.default],shallEvaluateParameters);
        }
    }
    
    private static generateView(viewGenerators:(()=>View<any>)[],shallEvaluateParameters:boolean){
        if(shallEvaluateParameters==true){
            let foundOne = viewGenerators.find(x=>x()!=null);
            if(foundOne==null)
                return viewGenerators.find(x=>x!=null)();
            return viewGenerators.find(x=>x()!=null)();
        }else{
            return viewGenerators.find(x=>x!=null)();
        }
    }

    private setupEvents(){
        let mediaList = [
            window.matchMedia("(min-width: 1025px)"),
            window.matchMedia("(min-width: 769px) and (max-width: 1024px) and (orientation: portrait)"),
            window.matchMedia("(min-height: 769px) and (max-height: 1024px) and (orientation: landscape)"),
            window.matchMedia("(min-width: 481px) and (max-width: 768px) and (orientation: portrait)"),
            window.matchMedia("(min-height: 481px) and (max-height: 768px) and (orientation: landscape)"),
            window.matchMedia("(min-width: 320px) and (max-width: 480px) and (orientation: portrait)"),
            window.matchMedia("(min-height: 320px) and (max-height: 480px) and (orientation: landscape)")
        ];
        mediaList.forEach(x=>{
            x.addEventListener('change',x=>{
                if(x.matches){
                    this.listenners.forEach(f=>f(x));
                }
            })
        })
    }
}
